import { render, staticRenderFns } from "./UserInfoSummary.vue?vue&type=template&id=b33cb814"
import script from "./UserInfoSummary.vue?vue&type=script&lang=js"
export * from "./UserInfoSummary.vue?vue&type=script&lang=js"
import style0 from "./UserInfoSummary.vue?vue&type=style&index=0&id=b33cb814&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports